import { useState } from "react";
import { API } from "@/lib/api";
import { todayISO } from "@/lib/constants";
import { FileArrowDown, Cow, Drop, ChartBar } from "@phosphor-icons/react";
import { toast } from "sonner";

async function download(url, filename) {
  const token = localStorage.getItem("token");
  try {
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error("Falha ao gerar PDF");
    const blob = await res.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
    toast.success("PDF gerado");
  } catch (e) {
    toast.error(e.message);
  }
}

export default function Reports() {
  const [inicio, setInicio] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 30);
    return d.toISOString().slice(0, 10);
  });
  const [fim, setFim] = useState(todayISO());

  return (
    <div data-testid="reports-page" className="space-y-6">
      <div>
        <h1 className="font-heading font-black text-4xl tracking-tighter">Relatórios</h1>
        <p className="text-sm text-[#4E544B] mt-1">
          Exporte dados do rebanho e da produção em formato PDF.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card
          icon={Cow}
          title="Rebanho completo"
          description="Todos os animais cadastrados com número, nome, grupo, sexo, nascimento, DEL e status."
          onClick={() =>
            download(`${API}/reports/rebanho`, "relatorio_rebanho.pdf")
          }
          testid="report-rebanho"
        />

        <div className="bg-white border border-[#E2E0D8] rounded-sm p-6 flex flex-col">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-sm bg-[#F6F5F2] border border-[#E2E0D8] flex items-center justify-center">
              <Drop size={20} weight="duotone" color="#2A5A3B" />
            </div>
            <h3 className="font-heading font-bold text-lg tracking-tight">
              Produção por período
            </h3>
          </div>
          <p className="text-sm text-[#4E544B] mb-4">
            Total, média e nº de registros por animal no intervalo escolhido.
          </p>
          <div className="grid grid-cols-2 gap-3 mb-4">
            <label className="block">
              <span className="text-xs font-bold uppercase tracking-[0.15em] text-[#4E544B] block mb-2">
                Início
              </span>
              <input
                type="date"
                data-testid="report-start"
                value={inicio}
                onChange={(e) => setInicio(e.target.value)}
                className="input"
              />
            </label>
            <label className="block">
              <span className="text-xs font-bold uppercase tracking-[0.15em] text-[#4E544B] block mb-2">
                Fim
              </span>
              <input
                type="date"
                data-testid="report-end"
                value={fim}
                onChange={(e) => setFim(e.target.value)}
                className="input"
              />
            </label>
          </div>
          <button
            data-testid="report-producao"
            onClick={() =>
              download(
                `${API}/reports/producao?data_inicio=${inicio}&data_fim=${fim}`,
                `producao_${inicio}_${fim}.pdf`,
              )
            }
            className="btn-primary inline-flex items-center justify-center gap-2 mt-auto"
          >
            <FileArrowDown size={16} weight="bold" /> Gerar PDF
          </button>
        </div>
      </div>

      <div className="bg-[#F6F5F2] border border-[#E2E0D8] rounded-sm p-6 flex items-center gap-4">
        <ChartBar size={28} weight="duotone" color="#2A5A3B" />
        <div>
          <div className="font-bold">Relatório individual do animal</div>
          <div className="text-sm text-[#4E544B]">
            Acesse a página de qualquer animal e clique em <b>Ficha PDF</b> para baixar o histórico completo.
          </div>
        </div>
      </div>
    </div>
  );
}

function Card({ icon: Icon, title, description, onClick, testid }) {
  return (
    <div className="bg-white border border-[#E2E0D8] rounded-sm p-6 flex flex-col">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-sm bg-[#F6F5F2] border border-[#E2E0D8] flex items-center justify-center">
          <Icon size={20} weight="duotone" color="#2A5A3B" />
        </div>
        <h3 className="font-heading font-bold text-lg tracking-tight">{title}</h3>
      </div>
      <p className="text-sm text-[#4E544B] mb-4 flex-1">{description}</p>
      <button
        data-testid={testid}
        onClick={onClick}
        className="btn-primary inline-flex items-center justify-center gap-2"
      >
        <FileArrowDown size={16} weight="bold" /> Gerar PDF
      </button>
    </div>
  );
}
